import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

@Directive({
  selector: '[ariaChecked]',
  standalone: true,
})
export class AriaCheckedDirective implements AfterViewInit, OnChanges {
  @Input() ariaCheckedElementId: string;

  @Input() ariaChecked: boolean | 'mixed' | null | undefined;

  private ariaCheckedElement: HTMLElement;

  constructor(private elementRef: ElementRef) {}

  ngAfterViewInit() {
    this.updateAriaCheckedElement();
    this.setAriaChecked();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['ariaCheckedElementId']) {
      this.updateAriaCheckedElement();
    }
    
    if (changes['ariaChecked']) {
      this.setAriaChecked();
    }
  }

  private updateAriaCheckedElement() {
    if (this.ariaCheckedElementId) {
      this.ariaCheckedElement = this.elementRef.nativeElement.querySelector(
        `#${this.ariaCheckedElementId}`
      );
    } else if (this.elementRef) {
      this.ariaCheckedElement = this.elementRef.nativeElement;
    }
  }

  private setAriaChecked() {
    if (!this.ariaCheckedElement) {
      return;
    }
    
    if (this.ariaChecked === null || this.ariaChecked === undefined) {
      this.ariaCheckedElement.removeAttribute('aria-checked');
    } else {
      this.ariaCheckedElement.setAttribute(
        'aria-checked',
        String(this.ariaChecked)
      );
    }
  }
}
